export class PodValidationWidgetCarrierManagerData {
  podPending = 0;
  podRejected = 0;
  podOutdatedLessThanOneWeek = 0;
  podOutdatedMoreThanOneWeek = 0;
  podToday = 0;
  podUnderReview = 0;
  podValidated = 0;

  public static fromDto(data: any): PodValidationWidgetCarrierManagerData {
    if (data === null) {
      return null;
    }

    const result = new PodValidationWidgetCarrierManagerData();

    result.podPending = data.pod_pending;
    result.podRejected = data.pod_rejected;
    result.podOutdatedMoreThanOneWeek = data.pod_outdated_more_than_one_week;
    result.podOutdatedLessThanOneWeek = data.pod_outdated_less_than_one_week;
    result.podToday = data.pod_today;
    result.podUnderReview = data.pod_under_review;
    result.podValidated = data.pod_validated;

    return result;
  }
}
